import Model from "../../utils/RestModel.js";
import Field from "../../utils/Field.js";
import App from "./App.js";
import setDefaults from "./utils/setDefaults.js";
import Linguist from "../../../lib/JuiS/Linguist.js";
import bankAccountLexicons from "./lexicons/product-group/productGroupLexicon.js";
import TicketTemplate from "./TicketTemplate.js";
import TicketType from "./TicketType.js";
import TicketStatus from "./TicketStatus.js";
import DynamicField from "./DynamicField.js";
import Ticket from "./Ticket.js";
import Filter from "../../utils/Filter.js";
import {concatenateUrls} from "juis-router/NavigationUtils.js";
import {createTextAreaEditor} from "../../components/fieldEditors/editorFactories.js";
import {imageThumbnailCellFactory} from "../../components/ImageThumbnail.js";
import {NOT_FOUND} from "juis-commons/Errors.js";

export default new Model(function () {
    this.app = new Field(App);
    this.code = new Field().asString().withLabel("Url Code");
    this.title = new Field().withLabel("Title").asTranslatableString();
    this.subtitle = new Field().withLabel("Subtitle").asTranslatableString();
    this.infoText = new Field().withLabel("InfoText").asTranslatableString().withEditorFactory(createTextAreaEditor);
    this.submitButtonText = new Field().withLabel("Submit Button Text").asTranslatableString();
    this.public = new Field().asBoolean().withLabel("Public");
    this.allowAnonymous = new Field().asBoolean().withLabel("Allow anonymous")
        .withHelp("Visitors without an account can fill in this form. They get an account from their email address.");
    this.ticketTemplate = new Field(TicketTemplate).withLabel("Template");
    this.fields = new Field([DynamicField]).withLabel("Fields")
        .withOptionsLoader(DynamicField.getOptionsLoaderForModel(Ticket));
    this.mainImage = new Field().asFile().withLabel("Image").withCellFactory(imageThumbnailCellFactory);
    this.makeTranslatable();
    setDefaults(this, {defaultField: this.title});

    this.getPublicByCode = (code, appCode) => this.getOptional(Filter.and(
        Filter.eq(this.code, code),
        Filter.eq(this.app.code, appCode)
    ), {url: "customer-forms/public"}).asPromise();

    this.getAllPublic = (appCode) => this.getList({
        filter: Filter.eq(this.app.code, appCode),
        url: "customer-forms/public"
    });

    /**
     * Loads a form for a visitor with no session. The server sends the form, its template and the app in one
     * response, because the normal endpoints for those need a login. The instances are created from it here, so
     * nothing has to be lazy loaded afterwards (that would be refused).
     */
    this.getPublicPage = (code, appCode) => this.fetchCustomEndpoint(`public/${appCode}`, code).then(response => {
        if (!response.data) {
            throw new Error(NOT_FOUND);
        }
        const {form, template, app, status, ticketType} = response.data;
        // Created in this order, so the ids in the form and the template find their instances in the cache
        new App(app);
        if (ticketType) {
            new TicketType(ticketType).setLazy(false);
        }
        if (status) {
            new TicketStatus(status).setLazy(false);
        }
        const templateInstance = new TicketTemplate(template);
        templateInstance.setLazy(false);
        return new this(form);
    });

    this.submit = (ticket, customerForm) => ticket.save({
        url: concatenateUrls(this.getEndpointUrl(), customerForm.id + "/submit")
    });


    new Linguist(bankAccountLexicons).withAudience(this);
}, "CustomerForm", "customer-forms");
